<script setup>
import { computed } from 'vue'
import { OhVueIcon } from 'oh-vue-icons';
import TranslationValue from '@/components/layouts/TranslationValue.ce.vue';
import TooltipBox from '@/components/layouts/TooltipBox.ce.vue';
import {useTranslationsStore} from "@/store/translations";
import {storeToRefs} from "pinia";

const translationStore = useTranslationsStore();
const { trans } = storeToRefs(translationStore);

const labelClasses = 'w-fit relative inline-flex items-center cursor-pointer';
const toggleClasses = 'bg-gray-100 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white peer-checked:bg-blue-600';
const toggleSize = 'p-2';
const toggleColor = 'peer-focus:ring-orange-300 peer-checked:bg-wageindicator-orange';

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    }
});

const emit = defineEmits(['updateToggle'])

const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('updateToggle', value)
    }
})

function getWidth(translationId) {
    const translatedValue = trans.value(translationId);

    const length = translatedValue.length;
    let decreaseFactor = 0.125 * Math.log(length + 1);
    const dynamicLength = length * (1 - decreaseFactor);

    return `${dynamicLength}rem`;
}

</script>
<template>
    <label
        class="relative"
        :class="labelClasses"
    >
        <input
            v-model="value"
            type="checkbox" class="sr-only peer"
        >
        <span
            :class="[toggleClasses, toggleSize, toggleColor]"
        >
              <OhVueIcon v-if="value" name="hi-chevron-double-up" class="text-slate-50" />
              <OhVueIcon v-else name="hi-chevron-double-down" class="text-slate-900" />
        </span>

        <TooltipBox
            class="text-center"
            :min-width="getWidth(value ? 'page2_toggle_hide' : 'page2_toggle_show')"
            top-offset="-4em"
        >
            <template v-if="value">
                <TranslationValue id="page2_toggle_hide"/>
            </template>
            <template v-else>
                <TranslationValue id="page2_toggle_show"/>
            </template>
        </TooltipBox>
    </label>
</template>
<style scoped>
label:hover > .tooltip-box {
    visibility: visible;
}
</style>
